import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@cpd-app/shared-module/shared.module';

import { MatchScoreChartComponent } from './match-score-chart/match-score-chart.component';
import { InterestsChartRadarComponent } from './interests-chart-radar/interests-chart-radar.component';
import { StackedBarChartComponent } from './stacked-bar-chart/stacked-bar-chart.component';
import { SemiCircleDonutChartsComponent } from './semi-circle-donut-charts/semi-circle-donut-charts.component';

const components = [
  MatchScoreChartComponent,
  InterestsChartRadarComponent,
  StackedBarChartComponent,
  SemiCircleDonutChartsComponent
];

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: components,
  exports: components
})
export class ChartsModule {}
